import Word from '../home/Word';
import RatingCard from '../home/RatingCard';
import PackageCard from '../home/PackageCard';
import { Carousel } from 'react-bootstrap';

export default function Beranda() {
  return (
    <div>
      <div className="container-fluid p-0 px-0 hero-header-1">
        <Carousel
          indicators={true}
          className="carousel-container"
          interval={3000}
        >
          <Carousel.Item>
            <div className="carousel-image">
              <img
                className="d-block w-100"
                src="assets/img/banner/artboard-1.jpg"
                alt="First slide"
              />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="carousel-image">
              <img
                className="d-block w-100"
                src="assets/img/banner/artboard-2.jpg"
                alt="Second slide"
              />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="carousel-image">
              <img
                className="d-block w-100"
                src="assets/img/banner/artboard-3.jpg"
                alt="Third slide"
              />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="carousel-image">
              <img
                className="d-block w-100"
                src="assets/img/banner/artboard-4.jpg"
                alt="Third slide"
              />
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
      <div className="parallax-container">
        <Word />
        <RatingCard />
      </div>
      <PackageCard />
    </div>
  );
}
